const platformIdReady = `<script>
(function () {
    function readCookie(name) {
        var n = name + '=';
        var cookie = document.cookie.split(';');
        for (var i = 0; i < cookie.length; i++) {
            var c = cookie[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(n) === 0) {
                return c.substring(n.length);
            }
        }
        return null;
    }

    Promise.resolve().then(function () {
        var pid = readCookie('platformId');
        if (pid) {
            window.dispatchEvent(new CustomEvent('platformIdReady', { detail: pid }));
        }
    });
})();
</script>`;

module.exports = {
    platformIdReady
};
